import React from 'react';
import cx from 'classnames';

import style from './HomeInsuranceSection.module.scss';

export default function HomeInsuranceSection() {
  return (
    <div className={style.section}>
      <div className="container">
        <div className={cx('lending-title', style.title)}>
          <div className={cx('icon-wrapper', style.iconWrapper)}>
            <span className="icon icon-process"></span>
          </div>

          <div className={cx('text', style.titleText)}>Service Obsessed</div>

          <div className={cx('hint', style.titleHint)}>
            World-class, customer-obsessed care for your company
          </div>
        </div>

        <div className={style.itemHolder}>
          <div className={style.itemWrapper}>
            <div>
              <div className={style.iconItem}>
                <span className="icon icon-insurance2" />
              </div>

              <div className={style.itemText}>
                Sense of Urgency/ Ownership Culture Insurance
              </div>
            </div>

            <div>
              <div className={style.iconItem}>
                <span className="icon icon-document" />
              </div>

              <div className={style.itemText}>Partnership Guidance</div>
            </div>

            <div>
              <div className={style.iconItem}>
                <span className="icon icon-document2" />
              </div>

              <div className={style.itemText}>
                Dedicated <br />
                Success Partner
              </div>
            </div>

            <div>
              <div className={style.iconItem}>
                <span className="icon icon-contract" />
              </div>

              <div className={style.itemText}>In-House Practical Expertise</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
